import { createSelector, OutputSelector } from 'reselect';
import { JurisdictionDetailsSelectorValues } from '@models/interfaces';
import { AppState } from '@store/reducers';
import { PermittingState } from '@store/reducers/permitting.reducer';

const permittingState = (state: AppState): PermittingState => state.permitting;

export namespace JurisdictionSelectors {
  export const isTabDataLoaded = (
    tabName: keyof PermittingState['jurisdictionDetailsData'],
  ) =>
    createSelector(
      [permittingState],
      (state: PermittingState) =>
        state.loadedJurisdictionTabs[tabName] || false,
    );

  export const getJurisdictionBrowseData = createSelector(
    [permittingState],
    (state: PermittingState) => state.jurisdictionBrowseData,
  );

  export const getJurisdictionDetailsData = (
    keys: Array<'summary' | 'zoning' | 'permitting' | 'contacts' | 'id'>,
  ): OutputSelector<
    [typeof permittingState],
    Partial<JurisdictionDetailsSelectorValues>,
    (res: PermittingState) => Partial<JurisdictionDetailsSelectorValues>
  > =>
    createSelector([permittingState], (state: PermittingState) => {
      const { contacts, permitting, zoning, id, ...summary } =
        state.jurisdictionDetailsData;

      const obj: JurisdictionDetailsSelectorValues = {
        id,
        summary,
        zoning,
        permitting,
        contacts,
      };

      return keys.reduce(
        (
          acc: Partial<JurisdictionDetailsSelectorValues>,
          v: 'summary' | 'zoning' | 'permitting' | 'contacts' | 'id',
        ) => ({ ...acc, [v]: obj[v] }),
        {} as Partial<JurisdictionDetailsSelectorValues>,
      );
    });

  // Contacts

  export const getJurisdictionContacts = createSelector(
    [permittingState],
    (state: PermittingState) => state.jurisdictionDetailsData.contacts,
  );
}
